module.exports = __webpack_public_path__ + "static/media/agent1.29ad41ad.png";